import '../styles/journey.css';
import { Col, Container } from 'react-bootstrap';
import { renderTextBlock } from '../components/RenderTextBlocks';
import { useProjectTracker } from '../useProjectTracker';
import Dropdown from 'src/components/Dropdown';
import downloadIcon from '../assets/img/download-pdf.png';
import { useMediaQuery } from 'react-responsive';
import { ArrowForwardIos } from '@mui/icons-material';

function Journey() {
    useProjectTracker();
    const isMobile = useMediaQuery({ maxWidth: 767 });

    return (
        <section className='journey'>
            <div className="banner" id="home">
                <Container className="width-base banner-container">
                    <div className="banner-text banner-row align-items-center justify-content-center text-center">
                        <Col size={12} md={7} className="banner-col banner-col-left">
                            <h1 className={isMobile ? "h1-mobile" : ""}>Curriculum<span style={{ color: "var(--color-accent)", transition: "color 0.2s ease-in-out" }}>.</span></h1>
                            <h5 className={isMobile ? "h4-mobile" : ""}>
                                {renderTextBlock(`My experience, education, and milestones.`)}
                            </h5>
                            <p>
                                {renderTextBlock(`A full breakdown of my game dev career, with highlights from work, school, certifications, and personal achievements.`)}
                            </p>
                        </Col>

                        <Col size={12} md={5} className="banner-col banner-col-right a-col-title-right col-md-5">
                            <a href="/linkedin-resume-en.pdf" download className="project-single-image journey-download-link">
                                <img src={downloadIcon} alt="download-icon" className="a-image loading-bg" />
                                <div className="carousel-title">Download .pdf</div>
                                <div className="journey-arrow-container">
                                    <ArrowForwardIos />
                                </div>
                            </a>
                        </Col>
                    </div>
                </Container>
            </div>

            <div className="a-body">

                <div className="a-body-block">
                    <Col size={12} md={12} className="a-body-left" style={{ marginTop: "0" }}>

                        <Dropdown label="Experiences" maxHeight='2000px'>
                            <div className="a-body-description">
                                {renderTextBlock(`**[Game Programmer]**

**Izyplay Game Studio** · Full-time · Remote
*June 2022 - Present*

• Translated game design ideas into gameplay features, created tools to improve workflows, and integrated visual elements and UI.
• Developed and adapted games for multiple platforms, primarily mobile, addressing compatibility challenges and optimizing for each platform.
• Played a crucial role in shaping and advancing the company’s key goals across various projects.
• Contributed to the company’s collective knowledge by sharing insights and fostering a culture of continuous learning.
• Documented processes, including best practices and troubleshooting guides, to assist new team members and improve productivity.

---
**[Full-Stack Web Developer]**

**PICSIZE** · Part-time · On-site
*February 2020 - March 2020*

• Designed systems from architecture to implementation, ensuring flexibility and responsiveness.
• Monitored performance, optimized resources, and implemented innovative solutions.
• Worked with programming paradigms like MVC, Serverless, Event-Driven, and Object-Driven.
• Utilized technologies such as NodeJS, React, Redux, Redis, AWS (EC2, S3, Lambda), Grafana, PostgreSQL, and MongoDB.

---
**[Full-Stack Web Development Intern]**

**PICSIZE · Internship · On-site**
*November 2019 - February 2020*

• Supported project development, performed tests, and debugged code.
• Contributed to documentation and researched technical solutions.
• Focused on learning and adapting to new technologies and workflows.`)}
                            </div>
                        </Dropdown>

                        <Dropdown label="Education" maxHeight='2000px'>

                            <div className="a-body-description">
                                {renderTextBlock(`**Bachelor’s Degree**, Digital Games
**PUC Minas**
*2023 - 2027*

---
**Bachelor’s Degree**, Control and Automation Engineering
**UFMG**
*2020 - 2022 (Unfinished)*

---
**Bachelor’s Degree**, Information Systems
**UFMG**
*2019 - 2020 (Unfinished)*

---
**Vocational Degree and High School**, Mechanics
**IFES**
*2015 - 2018*`)}

                            </div>
                        </Dropdown>

                        <Dropdown label="Certifications" maxHeight='2000px'>
                            <div className="a-body-description">
                                {renderTextBlock(`**Unity Junior Programmer**
**Unity** · Issued Nov 2021
[View Credential](https://www.credly.com/badges/4c092772-6255-48e5-86f5-600d04ed3c9a/public_url)

---
**Unity Essentials**
**Unity** · Issued Apr 2021
[View Credential](https://www.credly.com/badges/76963fad-b54a-41fe-beda-44059fd0246f/public_url)

---
**React Native**
**Rocketseat** · Issued Oct 2019

---
**APIs and Microservices**
**freeCodeCamp** · Issued Sep 2019
[View Credential](https://www.freecodecamp.org/certification/lcscout/back-end-development-and-apis)

---
**NodeJS**
**Rocketseat** · Issued Sep 2019

---
**ReactJS**
**Rocketseat** · Issued Sep 2019

---
**JavaScript Algorithms and Data Structures**
**freeCodeCamp** · Issued Aug 2019
[View Credential](https://www.freecodecamp.org/certification/lcscout/javascript-algorithms-and-data-structures)

---
**Responsive Web Design**
**freeCodeCamp** · Issued Mar 2019
[View Credential](https://www.freecodecamp.org/certification/lcscout/responsive-web-design)`)}
                            </div>
                        </Dropdown>

                        <Dropdown label="Timeline" maxHeight='4000px' startOpen={true}>
                            <div className="a-body-description">
                                {renderTextBlock(`**2015 - 2018**

**IFES**
It was during high school that I came in contact with programming for the first time. I learned the basics of C++ Language and soon wanted to learn another one. With the same will in mind, a friend of mine started learning Python, and I chose to learn Ruby, just to not copycat 😛. I learned it mostly by doing games using the Gosu gem, and it was pretty fun—this was also my introduction to game programming.

**Vocational degree in Mechanics [High school]**

---
**2019 - 2020 (Unfinished)**

**UFMG**
I knew I wanted to major in something technology-related, but I still didn't know what exactly I wanted to do. I started learning web development because I thought it had an easier entry barrier to get into the job market. Sadly, some things happened, and I decided to change my major. A decision that I wouldn’t do nowadays 💔, but, like it or not, it was an important thing that got me to where I am today.

**Information Systems, B. Sc. [College]**

---
**11/2019 - 03/2020**

**PICSIZE**
At this company we were a very small team of 6 people at a startup that has solutions for the photographer job flow, from the moment they finish taking pictures till they deliver them to their clients. Although I stayed there for a short time, it was an awesome experience. Mostly because I had the pleasure of being in contact with wonderful people from whom I learned a lot, both technically and personally. Besides, being my first real work experience, this had a huge impact on changing my worldview. And jumping from intern to full-time position very quickly is something I’m proud of 🥰.

**Full-stack Web Developer [Job]**

---
**2020 - 2022 (Unfinished)**

**UFMG**
I changed my major without putting much thought into it. I thought that I could have a better future going for a more traditional degree such as engineering. But during the pandemic, I changed my mind. Since the university was on hold, I started learning game dev as a hobby, later reigniting my passion and then studying it for 2 years straight 🧠. After that, I managed to enter the career path I’ve always dreamed about and eventually left the university.

**Control and Automation Engineering, B. Sc. [College]**

---
**01/2021 - 02/2021**

**S.U.B.**
During the pandemic, my college was on hold, so I decided to create a game, just for fun. I used the Phaser.js engine because I already knew JS programming, and it was very pleasing to do it. I think that doing the sprites by myself added a new layer of "proudness" that I didn't feel in previous games I did 👊.

**First "complete" game [Project]**

---
**04/2021 - 11/2021**

**Unity Pathway**
After creating S.U.B., I started playing with Blender and wanted to create some 3D games. I thought about using Babylon.js but chose to test Unity, and it was the best decision I made 🙌. So I did Unity's Essentials and Junior Programming pathways/courses to get started with the engine.

**Introduction to Unity [Course]**

---
**05/2021 - 06/2021**

**Warehouse Invasion**
Doing this game was a turning point for me. I did it because I wanted to practice the skills I had just learned from Unity's course. And doing it by myself was so gratifying that I realized I wanted to pursue a game development career 💪.

**Game development [Project]**

---
**06/2021 - 04/2022**

**Other game dev projects**
In order to learn effectively in practice, I decided the best course of action would be making a lot of small projects, each focused on an area of expertise. Later, I also developed some small games to have a solid foundation and study these areas of expertise in a closed and complete environment 🤗. You can check these projects and all the future ones here.

**Game development [Project]**

---
**06/2022 - Now**

**Izyplay Game Studio**
Before long, my hard work paid off. In my initial endeavors to break into the industry, Izyplay Game Studio believed in me and hired me as a game programmer. Becoming fully hired even before the probationary period was completed is something that fills me with immense pride. Today, I continue to collaborate with amazing individuals who welcomed me with open arms 😊. While I delve into more specific details about my responsibilities on my LinkedIn profile, one noteworthy accomplishment that I have to highlight is my involvement in Iza’s Supermarket. For a significant duration, I was the sole programmer driving this project, which has since become a major milestone of the company. Although I am no longer the sole programmer, I remain actively engaged as its lead programmer ✌️.

**Game programmer [Job]**`)}
                            </div>
                        </Dropdown>

                    </Col>
                </div>
            </div>

        </section >);
}

export default Journey;